import { render, staticRenderFns } from "./FundMessageDetail.vue?vue&type=template&id=311483ec&"
import script from "./FundMessageDetail.vue?vue&type=script&lang=ts&"
export * from "./FundMessageDetail.vue?vue&type=script&lang=ts&"
import style0 from "./FundMessageDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports